import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.itemSkus;

export const ItemSkusFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "SKU",
  Icon: TagIcon,
  operators: [...entry.operators],
  valueFetcher: fetcher,
  dbSearch: true,
  displayName: entry.displayName,
});
